<div class="table-view-table">
  @if (allFields?.length > 0 && reportRecordData?.length > 0) {
    <p-table
      [columns]="allFields"
      [value]="reportRecordData"
      >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th colspan="5">
            <div class="table-view-headers">
              <span class="title-bold">{{ currentTotalLabel }}</span>
              @if (reportRecordData.length === 1) {
                <span>{{
                  ' ' + ('recordPPT.record' | translate | titlecase)
                }}</span>
              } @else {
                <span>{{ ' ' + ('recordPPT.records' | translate | titlecase) }}</span>
              }
              <span>{{ ' - ' + ('recordPPT.totaling' | translate | titlecase) }}</span>
              @if (totalSizeField != null) {
                <span class="title-bold">
                  {{
                  reportRecordData
                  | reportFieldFormatter
                  : {
                  templateId: currentView().templateId,
                  field: totalSizeField,
                  joinString: true,
                  onlyUrl: false,
                }
                | async
                }}
              </span>
            }
          </div>
        </th>
      </tr>
      <tr class="table-view-headers">
        <th [ngClass]="{ pdfTable: isPDF() }">#</th>
        @if (isEntityWithConfidentiality && confidentialityTmpl()) {
          <th
            [ngClass]="{ pdfTable: isPDF() }"
            [ngClass]="{ 'tableView-confidentialityTmpl()': confidentialityTmpl() }"
            >
            <div class="compare-cell header confidentiality">
              {{ 'template.reportViewState' | translate | titlecase }}
            </div>
          </th>
        }
        @for (col of columns; track col) {
          <th class="{{ col.class }}" [ngClass]="{ pdfTable: isPDF() }">
            <span class="header-label"> {{ col.label | titlecase }}</span>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-catalog let-columns="columns" let-i="rowIndex">
      <tr [pReorderableRow]="i" (dragstart)="dragStartColumn(i)" (dragend)="dropColumn(i)" draggable="true">
        <!-- TECH DEBT (Sanjay): need to pass highlight field from configurations -->
        <td
          class="sno"
          [ngClass]="{
            'highlighted-date':
              catalog | highlightDatePipe: reportOptions().highlightDate : 'entity.edp_last_update_date',
            pdfTable: isPDF(),
          }"
          >
          {{ i + 1 }}.
          @if (!isPDF()) {
            <i class="fa fa-arrows move-record" pReorderableRowHandle></i>
          }
          @if (!isPDF()) {
            <mat-icon
              class="green-close"
              color="y-icon"
              svgIcon="close-icon-grey"
              (click)="removeRecord.emit(catalog)"
            ></mat-icon>
          }
          @if (!isPDF()) {
            <ng-container
              [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet : 'miq-goes-to-record'"
            [ngTemplateOutletContext]="{
              classes: '',
              urlParams:
                catalog | reportRecordRouteFn: { templateId: currentView().templateId, entity: reportData().entity },
              content: goToIcon,
            }"
            ></ng-container>
          }
          <ng-template #goToIcon>
            <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
          </ng-template>
        </td>
        @if (isEntityWithConfidentiality && confidentialityTmpl()) {
          <td
            [ngClass]="{ 'tableView-confidentialityTmpl()': confidentialityTmpl() }"
            >
            <ng-container
            *ngTemplateOutlet="
              confidentialityTmpl();
              context: { reportItem: catalog, displayLabel: true, isDataOnly: true }
            "
            ></ng-container>
          </td>
        }
        @for (col of columns; track col) {
          <td [ngClass]="{ pdfTable: isPDF() }" class="{{ col.dataClass }}">
            @if (col.id === confidentialityId) {
              <div>
                @if (
                  templateProjectionMap() &&
                  (templateProjectionMap() | selectTemplateOutlet : 'miq-confidentiality-control-tmpl')) {
                  <ng-container
                    [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet : 'miq-confidentiality-control-tmpl'"
                    [ngTemplateOutletContext]="{ reportItem: catalog, displayLabel: !isPDF(), isDataOnly: true }"
                    >
                  </ng-container>
                } @else {
                  <span>{{ catalog.confidentiality }}</span>
                }
              </div>
            } @else {
              <span
                class="table-data-cells"
              [ngClass]="{
                clickable:
                  editableFieldsService.editableTemplateAttributes[col.id] && !nonEditableFieldIds.includes(col.id),
              }"
                (click)="emitEditableFields($event, col.id, catalog.data)"
                >
                {{
                catalog
                | reportFieldFormatter
                : {
                templateId: currentView().templateId,
                field: col,
                joinString: true,
                onlyUrl: false,
                reportOptions: reportOptions(),
              }
              | async
              }}
            </span>
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>
}
</div>
